import SectionPlacePictureList from './SectionPlacePictureList.container';

export default SectionPlacePictureList;
